<template>
  <ContentPage :back="{ name: automatic ? 'leads/choose' : 'leads/append' }">
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Your Referral</div>
    </template>

    <div class="d-flex flex-column" style="width: 100%">
      <!-- Customer Section -->
      <Section>
        <template #header>
            <strong style="color:black">Request</strong>
        </template>

        <Item icon="mdi-account">{{ currentRequest.name }}</Item>
        <Item icon="mdi-phone">{{ currentRequest.phone }}</Item>
      </Section>

      <!-- Service -->
      <Section>
        <template #header>
          <strong style="color:black">Service Requested</strong>
        </template>

        <div class="pl-2" v-if="prettyStructureType">
          {{ prettyStructureType }} / {{ currentRequest.service.service }}
        </div>
        <div class="pl-2" v-else>
          {{ currentRequest.service.service }}
        </div>
      </Section>

      <div class="mt-8 d-flex justify-center">
        <v-btn 
          width="60%" 
          color="primary"
          @click="confirmClick"
        >
          Confirm
        </v-btn>
      </div>
      <div class="mt-4 d-flex justify-center">
        <v-btn :to="{ name: 'referrals' }" width="60%">Cancel</v-btn>
      </div>
      <v-overlay absolute :value="overlay">
        <div class="d-flex flex-column align-center">
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="primary"
            v-if="loading"
          ></v-progress-circular>

          <ConfirmationDialog v-model="confirmedDialog" @done="doneClick"/>
        </div>
      </v-overlay>
    </div>
  </ContentPage>
</template>


<script>
import ConfirmationDialog from '../Referrals/ConfirmationDialog'
import { ContentPage, Section, Item } from '@/components/pages'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: { ConfirmationDialog, ContentPage, Section, Item },

  props: {
    id: { required: true },
    automatic: { type: Boolean, default: false }
  },

  data: () => ({
    overlay: false,
    loading: false,
    confirmedDialog: false,
  }),

  computed: {
    ...mapGetters('auth', ['settings']),
    ...mapGetters('customer_requests', ['currentRequest', 'currentPros']),

    prettyStructureType() {
      if (!this.settings?.structure_types)
        return ""

      return this.settings.structure_types[this.currentRequest.structure_type]
    },
  },

  methods: {
    ...mapActions('auth', ['loadSettings']),
    ...mapActions('referrals', ['createReferrals']),
    ...mapMutations('referrals', ['clearAll']),

    async confirmClick() {
      this.overlay=true
      this.loading=true

      const payload = {
        customer_request_id: this.currentRequest.customer_request_id,
        referral_type: this.automatic ? 'automatic' : 'manual',
      }
      if (!this.automatic) { payload.pro_ids = this.currentPros.map( p => p.pro_id ) }

      const result = await this.createReferrals(payload)
      if (result.ok) {
        this.loading = false
        this.confirmedDialog = true
      } else {
        console.log('referral creation failed')
        this.overlay = false
      }
    },

    doneClick() {
      this.overlay=false
      this.clearAll()
      this.$router.replace({ name: 'leads/show', params: { id: this.id } })
    },

  },

  async created() {
    this.loading = true

    await this.loadSettings()
    await this.loadCurrent(this.id)

    this.loading = false
  },
}

</script>